import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./components/authen/AuthContext";

import Login from "./components/authen/login";
import AdminLayout from "./components/layout/AdminLayout";
import Dashboard from "./components/dashboard/dashboard";
import Menu from "./components/menu/menu";
import Inventory from "./components/inventory/inventory";
import Purchase from "./components/inventory/purchase";
import IssueItems from "./components/inventory/IssueItems";
import TransferStock from "./components/inventory/TransferStock";
import DiscountMaster from "./components/discounts/DiscountMaster";
import ExpenseMaster from "./components/expenses/ExpenseMaster";
import Order from "./components/orders/order";
import OrderHistory from "./components/orders/OrderHistory";
import KitchenBoard from "./components/kitchen/KitchenBoard";
import DeliveryBoard from "./components/delivery/DeliveryBoard";
import Settings from "./components/settings/settings";
import Users from "./components/settings/users";
import Branches from "./components/settings/branches";
import SalesReport from "./components/reports/SalesReport";
import ProfitReport from "./components/reports/ProfitReport";
import InventoryReport from "./components/reports/InventoryReport";

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="order" element={<Order />} />
            <Route path="orders-history" element={<OrderHistory />} />
            <Route path="kitchen" element={<KitchenBoard />} />
            <Route path="delivery" element={<DeliveryBoard />} />
            <Route path="menu" element={<Menu />} />
            <Route path="purchases" element={<Purchase />} />
            <Route path="inventory" element={<Inventory />} />
            <Route path="issues" element={<IssueItems />} />
            <Route path="transfers" element={<TransferStock />} />
            <Route path="discounts" element={<DiscountMaster />} />
            <Route path="expenses" element={<ExpenseMaster />} />
            <Route path="reports/sales" element={<SalesReport />} />
            <Route path="reports/profit" element={<ProfitReport />} />
            <Route path="reports/inventory" element={<InventoryReport />} />
            <Route path="settings/general" element={<Settings />} />
            <Route path="settings/branches" element={<Branches />} />
            <Route path="settings/users" element={<Users />} />
          </Route>
          
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}
